import { EnvScheduleService } from 'src/app/services/api/env-schedule.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { translate } from '@jsverse/transloco';
import { Component, ChangeDetectorRef, ComponentRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, inject, DestroyRef } from '@angular/core';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { EnvironmentTableComponent } from '../../environment-table/environment-table.component';
import { EnvironmentPaginatorComponent } from '../../environment-paginator/environment-paginator.component';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ColumnFilterComponent } from 'src/app/main/instances-mgmt/column-filter/column-filter.component';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-environment-jobs',
  templateUrl: './environment-jobs.html',
  styleUrl: './environment-jobs.scss',
  standalone: false
})
export class EnvironmentJobs implements OnInit {
@ViewChild(EnvironmentPaginatorComponent) paginatorRef: EnvironmentPaginatorComponent;
@ViewChild(EnvironmentTableComponent) tableRef: EnvironmentTableComponent;
  private destroyRef = inject(DestroyRef);
  @Input() data: any;
  @Input() scheduleJobData: any;
  @Output() clearAll = new EventEmitter<void>();
  @Input() instance: any;
  isJobTableLoaded = true;
  jobsData: any;
  searchTerm: string = '';
  searchedResult = [];
  isRefreshing = false;
  showLoader = false;
  isFiltered = false;
  runbookType: any;
  scheduleName: any;
  runbookName: any;
  jobStatus: any;
  createdDate: any;
  dropdownsList: any;
  filteredColumns: any;
  clearData: boolean;
  filterStartDate: any;
  filterEndDate: any;
  selectedStatus = [];
  status: any;
  selectedSchedule = [];
  selectedRunbook = [];
  pageName = 'job';
  dataJobs:any;
  pageIndex = 0;
  paginationSize = 10;
  jobLoading = true;
  envJobResponse = false;
  apiNotFound = false;
  instanceId: any;
  schedule: any;
  clearJobFilter = "false";


 displayColumns = [
    {
      key: 'jobName',
      name: 'JOBS.JOB_NAME',
      type: 'text',
      sortable: false,
      visible: true,
      disable: true,
      keyLink: 'navigation'
    },
    {
      key: 'scheduleName',
      name: 'JOBS.SCHEDULE',
      type: 'text',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'runbookName',
      name: 'RUNBOOK.RUNBOOK',
      type: 'text',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'createdAt',
      name:  'JOBS.CREATED_DATE',
      type: 'date',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'status',
      name: 'RUNBOOK.STATUS',
      type: 'status',
      statusKey: 'jobName',
      visible: true,
      disable: true,
      sortable: false
    },
    {
      key: 'runbookSettings',
      name: '',
      type: 'settings',
      visible: true,
      disable: true
    }
  ];

   constructor(private activatedRoute: ActivatedRoute, private schedulerService: EnvScheduleService,  public datePipe: DatePipe,  public sidenavService: SidenavService, private toastrService: CustomToastrService,  private cdr: ChangeDetectorRef, private envScheduleService: EnvScheduleService) {

   }

  ngOnInit(): void {
     this.instanceId = this.activatedRoute.snapshot.params.instanceId;
     if (localStorage.getItem('filteredSchedule')) {
      const userData = JSON.parse(localStorage.getItem('filteredSchedule'));
      if (userData) {
        this.selectedSchedule = userData;
        this.runbookType = this.selectedSchedule;
        this.dropdownsList?.[0]?.options?.forEach(element => {
          if(this.selectedSchedule.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
     if (localStorage.getItem('filteredRunbook')) {
      const userData = JSON.parse(localStorage.getItem('filteredRunbook'));
      if (userData) {
        this.selectedRunbook = userData;
        this.runbookType = this.selectedRunbook;
        this.dropdownsList?.[1]?.options?.forEach(element => {
          if(this.selectedRunbook.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
     if (localStorage.getItem('filteredJobStatus')) {
      const userData = JSON.parse(localStorage.getItem('filteredJobStatus'));
      if (userData) {
        this.selectedStatus = userData;
        this.runbookType = this.selectedStatus;
        this.dropdownsList?.[2]?.options?.forEach(element => {
          if(this.selectedStatus.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
   if (localStorage.getItem('filteredCustomDate')) {
      const userData = JSON.parse(localStorage.getItem('filteredCustomDate'));
      if (userData) {
        this.createdDate = userData;
        this.runbookType = this.createdDate;
        this.dropdownsList?.[3]?.options?.forEach(element => {
          if(this.createdDate.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
   this.fetchSchedule();
   if(!this.scheduleJobData){
   this.resetJobFilter();
   }
  }

  search(searchTerm?: string): void {
    this.searchTerm = searchTerm;
  }

 onPageChange(event) {
    this.paginationSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
   }

  onTablePageChanged(event) {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
  }

  refreshClick(): void {
    this.isRefreshing = true;
    this.jobLoading = true;
  if (this.isFiltered) {
    setTimeout(() => {
      this.isRefreshing = false;
      this.jobLoading = false;
    }, 1000);
    return;
  }

  if (this.paginatorRef) {
    this.paginatorRef.pageIndex = 0;
  }

  this.fetchSchedule();

  setTimeout(() => {
    this.isRefreshing = false;
    this.jobLoading = false;
  }, 1000);
  }


  searchedItems(result): void {
    this.searchedResult = result;
    this.cdr.detectChanges();
  }


   resetPaginator() {
     this.pageIndex = 0;
     this.paginatorRef.pageIndex = 0;
  }

   getJobsDetail(): void {
    this.isJobTableLoaded = false;
    this.showLoader = true;
     this.schedulerService.getInstanceJobs(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(results => {
        if (results.total > 10) {
          const size = results.total;
          this.schedulerService.getInstanceJobs(this.instanceId, size)
           .pipe(takeUntilDestroyed(this.destroyRef))
           .subscribe(response => {
             this.showLoader = false;
             this.jobLoading = false;
             this.jobsData = response;
             this.dataJobs = this.jobsData?.data
              ?.sort((a, b) =>
                 new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
                )
                 ?.map((job, index) => ({
                   ...job,
                   jobName: `job${index + 1}`
                 }));
               this.dataJobs = this.dataJobs?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

               this.schedule?.length > 0 ? this.envJobResponse = true : this.envJobResponse = false;
               this.initializeFilterItems();
             });
         } else {
            this.showLoader = false;
            this.jobLoading = false;
            this.jobsData = results;
            this.dataJobs = this.jobsData?.data
            ?.sort((a, b) =>
              new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
            )
            ?.map((job, index) => ({
              ...job,
              jobName: `job${index + 1}`
            }));
            this.dataJobs = this.dataJobs?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

            this.schedule?.length > 0 ? this.envJobResponse=true: this.envJobResponse = false;
            this.initializeFilterItems();
         }
      },
      (error) => {
          this.showLoader = false;
          this.isJobTableLoaded = true;
          this.apiNotFound = true;
          setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });

  }
  initializeFilterItems(){
    this.scheduleName = Array.from(
      new Set(this.schedule?.map((item) => item.name || '-'))).filter((scheduleName) => scheduleName && scheduleName !== '-').map((scheduleName) => ({
        value: scheduleName,
        label: scheduleName,
        selected: false,
      }));

    this.runbookName = Array.from(
      new Set(this.schedule?.map((item) => item.runbookName || '-'))).filter((runbookName) => runbookName && runbookName !== '-').map((runbookName) => ({
        value: runbookName,
        label: runbookName,
        selected: false,
      }));

      this.jobStatus = [
      {value: 'running', label: "Running",selected: false},
      {value: 'completed', label: "Completed",selected: false},
      {value: 'failed', label: "Failed",selected: false}
    ];

     const createdDate = [
      {value: 'Created Date', selected: false}
    ];





    this.dropdownsList = [
      {
        title: 'Schedule',
        placeholder: 'Select Schedule',
        options: this.scheduleName
      },
      {
        title: 'Runbook',
        placeholder: 'Select Runbook',
        options: this.runbookName
      },
      {
        title: 'Status',
        placeholder: 'Select Status',
        options: this.jobStatus
      },
      {
        title: 'Date',
        placeholder: 'Select Date',
        options: createdDate
      }
    ];

     // display jobs via schedule
       if (localStorage.getItem('clearJobFilter')) {
        this.clearJobFilter = JSON.parse(localStorage.getItem('clearJobFilter'));
       }


      if (this.scheduleJobData) {
        const scheduleName = this.scheduleJobData.name;
        this.selectedSchedule = [scheduleName];
        this.dropdownsList[0].options.forEach(option => {
          option.selected = option.value === scheduleName;
        });

      // Filter the table
      this.dataJobs = this.dataJobs.filter(
        job => job.scheduleName === this.scheduleJobData.name
      );
  }
}
    filterColumns(): void {
      if(this.scheduleName) {
        this.dropdownsList[0]?.options.filter((item) => {
          if (this.scheduleName?.find(type => type === item.value)) {
            item.selected = true;
          }
        });
      }
      if(this.runbookName) {
        this.dropdownsList[1]?.options.filter((item) => {
          if (this.runbookName?.find(status => status === item.value)) {
            item.selected = true;
          }
        });
      }
      if(this.jobStatus) {
        this.dropdownsList[2]?.options.filter((item) => {
          if (this.jobStatus?.find(version => version === item.value)) {
            item.selected = true;
          }
        });
      }
       if(this.createdDate) {
        this.dropdownsList[3]?.options.filter((item) => {
          if (item.value === this.createdDate) {
            item.selected = true;
          }
        });
      }


      const data = {
        name: translate('JOBS.JOBS'),
        title: translate('INSTANCE_STATUS.FILTER_TITLE'),
        subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
        filteredColumns: this.dropdownsList,
        scheduleList: this.dropdownsList?.[0].options,
        runbookList: this.dropdownsList?.[1].options,
        statusList: this.dropdownsList?.[2].options,
        dateCreated: this.data?.dateCreated,
        Date: this.dropdownsList?.[3].options,
        jobStartDateChange: this.dropdownsList?.[3].options?.[0]?.selected ? moment(this.filterStartDate) : '',
        jobEndDateChange: this.dropdownsList?.[3].options?.[0]?.selected ? moment(this.filterEndDate) : '',
        jobsColumns: [
          'schedule',
          'runbook',
          'status',
          'date'
        ]
      };
      this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(filteredColumns => {
        this.filteredColumns = filteredColumns;
        if (filteredColumns) {
          this.isFiltered = true;
          this.clearData = true;
          if(filteredColumns[0] !== '') {
            this.scheduleName = filteredColumns[0];
          }
          if(filteredColumns[1] !== '') {
            this.runbookName = filteredColumns[1];
          }
          if(filteredColumns[2] !== '') {
            this.jobStatus = filteredColumns[2];
          }
          if(filteredColumns[3] !== '') {
            localStorage.removeItem('filteredJobDate');
            this.createdDate = filteredColumns[3];
            localStorage.setItem('filteredJobDate', JSON.stringify(filteredColumns[3]));
          }
           if (filteredColumns[0]?.length === 0 && filteredColumns[1]?.length === 0 && filteredColumns[2]?.length === 0 && filteredColumns[3]?.length === 0){
            this.resetJobFilter();
          } else {
            this.filterJobItems(filteredColumns);
          }
        }
      });
    }


  /* Reset the selected job filter */
  resetJobFilter(): void {
    this.isFiltered = false;
    this.selectedStatus = [];
    this.selectedRunbook = [];
    this.selectedSchedule = [];
    this.sidenavService.searchFilter.next('dataJobs');
    this.dropdownsList?.[0]?.options?.filter((item) => {item.selected = false});
    this.dropdownsList?.[1]?.options.filter((item) => {item.selected = false});
    this.dropdownsList?.[2]?.options?.filter((item) => {item.selected = false});
    this.dropdownsList?.[3]?.options?.filter((item) => {item.selected = false});
    this.status = undefined;
    this.scheduleName = undefined;
    this.runbookName = undefined;
    this.jobStatus = undefined;
    this.createdDate = undefined;
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    this.scheduleJobData = undefined;
    localStorage.setItem('clearJobFilter',"true");
    this.schedule = [];
   // this.dataJobs = this.jobsData;
     this.dataJobs = this.jobsData?.data?.map((job, index) => ({
      ...job,
     jobName: job.jobName ? job.jobName : `job${index + 1}`
     }));
    localStorage.removeItem('filteredSchedule');
    localStorage.removeItem('filteredRunbook');
    localStorage.removeItem('filteredJobStatus');
    localStorage.removeItem('filteredJobDate');
    localStorage.removeItem('filteredJobStartDate');
    localStorage.removeItem('filteredJobEndDate');
    this.clearAll.emit();
  }

    /* Filters the Runbook table data based on the selected filter criteria. */
    filterJobItems(filteredColumns): void {
      if (filteredColumns) {
         this.dataJobs = this.jobsData?.data?.map((job, index) => ({
            ...job,
          jobName: job.jobName ? job.jobName : `job${index + 1}`
          }));
        this.selectedStatus = [];
        this.selectedSchedule = [];
        this.selectedRunbook = [];
        if (filteredColumns[0]?.length > 0) {
          this.selectedSchedule = filteredColumns[0];
          if (filteredColumns[0].length > 0) {
            localStorage.setItem('filteredSchedule', JSON.stringify(this.selectedSchedule));
            this.dataJobs = this.dataJobs?.filter(item => this.selectedSchedule?.includes(item?.scheduleName));
          } else {
            localStorage.removeItem('filteredSchedule');
          }
        }
        if (filteredColumns[1]?.length > 0) {
          this.selectedRunbook = filteredColumns[1];
          if (filteredColumns[1]?.length > 0) {
            localStorage.setItem('filteredRunbook', JSON.stringify(this.selectedRunbook));
            this.dataJobs = this.dataJobs?.filter(item => this.selectedRunbook?.includes(item?.runbookName));
          } else {
            localStorage.removeItem('filteredRunbook');
          }
        }
        if (filteredColumns[2]?.length > 0) {
          this.selectedStatus = filteredColumns[2];
          if (filteredColumns[2].length > 0) {
            localStorage.setItem('filteredJobStatus', JSON.stringify(this.selectedStatus));
            this.dataJobs = this.dataJobs?.filter(item => this.selectedStatus?.includes(item?.status));
          } else {
            localStorage.removeItem('filteredJobStatus');
          }
        }

        if (this.dropdownsList[3]?.options[0].selected && moment(filteredColumns[3][1]?.filteredStartDate).isValid() && moment(filteredColumns[3][1]?.filteredEndDate).isValid()) {
          this.filterStartDate = filteredColumns[3][1]?.filteredStartDate;
          this.filterEndDate = filteredColumns[3][1]?.filteredEndDate;
          localStorage.setItem('filteredJobStartDate', this.filterStartDate);
          localStorage.setItem('filteredJobEndDate', this.filterEndDate);

          const startDateUTC = moment.utc(moment(this.filterStartDate).format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day');
          const endDateUTC = moment.utc(moment(this.filterEndDate).format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day');
          this.dataJobs = this.dataJobs?.filter(item => {
            const itemDateUTC = moment.utc(item.createdAt).startOf('day');
            return itemDateUTC.isSameOrAfter(startDateUTC) && itemDateUTC.isSameOrBefore(endDateUTC);
          });

        } else {
          this.filterStartDate = undefined;
          this.filterEndDate = undefined;
          localStorage.removeItem('filteredJobStartDate');
          localStorage.removeItem('filteredJobEndDate');
        }
      }
    }


      /* Returns a label for the Type */
       getScheduleLabel(schedule): void {
        // return this.selectedType?.find(item=> item.value === type).label;
        return this.selectedSchedule?.find(item => item.value === schedule)?.label || schedule || '';

      }

      /* Returns a label for the Status */
      getRunbookLabel(runbook): void {
        // return this.runbookStatus?.find(item=> item.value === status).label;
            return this.selectedRunbook?.find(item => item.value === runbook)?.label || runbook || '';

      }

      /* Returns a label for the Version */
  getStatusLabel(status): void {
    // return this.runbookVersion?.find(item=> item.value === version).label;
            return this.selectedStatus?.find(item => item.value === status)?.label || status || '';

  }

  /* Converts the given date into a UTC timestamp. */
  getUTCTimestamp(date): any {
    return Date.parse(moment(new Date(date)).utc().format('DD MMM YYYY HH:mm:ss'));
  }

       /* Cleares the selected Status filter */
  cancelScheduleFilter(data) {
    localStorage.setItem('clearJobFilter',"true");
    this.scheduleJobData ? this.filteredColumns = this.dropdownsList : '';
    this.scheduleJobData = undefined;
    this.schedule = [];
    let selectedItem = this.selectedSchedule.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredSchedule');
      this.selectedSchedule.splice(selectedItem, 1);
      this.dropdownsList[0].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredSchedule', JSON.stringify(this.selectedSchedule));
      this.filterJobItems(this.filteredColumns);
    }
     this.clearAll.emit();
  }

  /* Cleares the selected Status filter */
  cancelStatusFilter(data) {
    let selectedItem = this.selectedStatus.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredJobStatus');
      this.selectedStatus.splice(selectedItem, 1);
      this.dropdownsList[2].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredJobStatus', JSON.stringify(this.selectedStatus));
      this.filterJobItems(this.filteredColumns);
    }
  }

    /* Cleares the selected Version filter */
  cancelRunbookFilter(data) {
    let selectedItem = this.selectedRunbook.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredRunbook');
      this.selectedRunbook.splice(selectedItem, 1);
      this.dropdownsList[1].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredRunbook', JSON.stringify(this.selectedRunbook));
      this.filterJobItems(this.filteredColumns);
    }
  }

   /* Cleares the selected Date filter */
  cancelJobDateFilter() {
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    this.dropdownsList?.[3]?.options?.filter((item) => {item.selected = false});
    this.createdDate?.forEach(element => {
      if(element.includes(this.dropdownsList[3].options[0].value)) {
        this.createdDate.pop(element);
      }
    });
    localStorage.removeItem('filteredJobStartDate');
    localStorage.removeItem('filteredJobEndDate');
    localStorage.removeItem('filteredCustomDate');
    localStorage.removeItem('filteredJobDate');
    this.filterJobItems(this.filteredColumns);
  }

  fetchSchedule(): void {
    this.showLoader = true;
    this.envScheduleService.getSchedule(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(response => {
          response = response;
          this.schedule = response;
          this.getJobsDetail();

        },
         (error) => {
          if (error.httpStatusCode === 404){
          this.apiNotFound = true;
        } else {
          this.showLoader = false;
          this.initializeFilterItems();
          setTimeout(() => {
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
            this.toastrService.errMessage(message, title);
          }, 500);
        }
        });
    }



}
